module.exports = __webpack_public_path__ + "img/logotipo-dark.57e013a0.svg";